// Magyarország
export default {
	tabs: ["Kivonás", "Történelem"],
	History: {
		tabs: ["Áttekintés", "Siker", "Elutasítás"]
	},
	Withdraw: {
		label: ["Számlaszám", "Rendelésszám", "Cím", "Összeg", "Díj", "Létrehozva", "Állapot", "Indoklás"]
	},
	AccountAmount: "Számla összege",
	tips: "A kivonást egy órán belül megkapja",
	form: {
		label: ["Kivonni kívánt összeg", "Tranzakciós jelszó"],
		ALL: "MIND",
		Withdraw: "Beküldés"
	},
	WithdrawAccount: "Számla visszavonása",
	noAccountsTips: "Kérjük, adjon hozzá fizetési módokat",
	tradingKind: [
		"Készpénz-visszatérítés",
		"Levonás",
		"Feltöltés",
		"Kifizetés folyamatban",
		"Kifizetés feloldása",
		"Kifizetés",
		"Feladat",
		"Tőke visszatérítése",
		"Jutalék visszatérítése",
		"Alárendelt jutalék visszatérítése",
		"Bejelentkezés",
		"Kezelési díj",
		"Befizetés",
		"Jutalom",
		"Alapbér",
		"Készpénzes segítség",
		"Regisztrációs bónusz",
		"Áruosztalék",
		"Feladatbónusz",
		"Egyéb",
		"",
		"Munkabónusz",
		"Szintlépési jutalmak",
		"Támogatás",
		"Függőben lévő ellenőrzés",
		"Kampány",
		"Pontbeváltás",
		"Bejelentkezési jutalmak",
		"Munkajutalmak",
		"Hitelpont tranzakció"
	]
};
